"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const DashboardController_1 = __importDefault(require("./class/controllers/DashboardController"));
const DashboardHeader_vue_1 = __importDefault(require("./views/DashboardHeader.vue"));
const DashboardMain_vue_1 = __importDefault(require("./views/DashboardMain.vue"));
const DashboardBanner_vue_1 = __importDefault(require("@becrop/components/Common/DashboardBanner.vue"));
const ThirdPartiesPackage_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/ThirdPartiesPackage.vue"));
let DashboardView = class DashboardView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controller = new DashboardController_1.default();
    }
    created() {
        this.controller.init('/dashboard/new_version');
    }
    get userName() {
        return this.vuedata.user.name;
    }
    get dataset() {
        return this.controller.getData;
    }
    get farmDataSet() {
        var _a;
        return (_a = this.controller.getFarmData) === null || _a === void 0 ? void 0 : _a.slice(0, 5);
    }
    get lastProjects() {
        return this.controller.lastProjects;
    }
    get lastSamples() {
        return this.controller.lastSamples;
    }
    get projectsTypes() {
        return this.controller.projectsTypes;
    }
    get samplesCrops() {
        return this.controller.samplesCrops;
    }
    get isLoading() {
        return this.controller.isLoading;
    }
    updateFilter(newFilter) {
        this.controller.updateFilter(newFilter);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DashboardView.prototype, "vuedata", void 0);
DashboardView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DashboardMain: DashboardMain_vue_1.default,
            DashboardHeader: DashboardHeader_vue_1.default,
            Loader: bmk_ui_framework_1.Loader,
            ThirdPartiesPackage: ThirdPartiesPackage_vue_1.default,
            DashboardBanner: DashboardBanner_vue_1.default
        },
    })
], DashboardView);
exports.default = DashboardView;
